module.exports = "<div class=\"gw-shopping-card-icon-content\"\r\n     ng-if=\"visible()\"\r\n     ng-click=\"triggerHistory()\">\r\n    <i class=\"fa fa-shopping-cart\"></i>\r\n    <sup class=\"gw-number-of-changes\">{{changesNo}}</sup>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/endorsement/common/directives/templates/shopping-cart-icon.html
// module id = 577
// module chunks = 0